import React, { useEffect, useState } from 'react';
import { PiFacebookLogo } from 'react-icons/pi';
import { PiInstagramLogo } from 'react-icons/pi';
import { PiTelegramLogoBold } from "react-icons/pi";
import './contact.css';

const Contact = ({ navbarHeight }) => {
  const [section1Height, setSection1Height] = useState(0);

  useEffect(() => {
    const newHeight = window.innerHeight - navbarHeight;
    setSection1Height(newHeight);
  }, [navbarHeight]);

  return (
    <div className="contact">
      <div
        className="contact-section1"
        style={{ height: `${section1Height}px` }}
      >
        <h1>KONTAKT</h1>
        <div className="contact-section1-container">
          <h3>ADRESA</h3>
          <div className="contact-section1-container-text-left">
            <p>OZ Zachráň zajka</p>
            <p>Kominárska 2</p>
            <p>Bratislava 831 04</p>
          </div>
          <div className="contact-section1-container-text-right">
            <p>info@zachranzajka.sk</p>
          </div>
        </div>
        <div className="contact-section1-socials">
          <a
            target="_blank"
            href="https://www.facebook.com/share/g/1Eb3usBrXC/?mibextid=wwXIfr"
          >
            <PiFacebookLogo />
          </a>
          <a
            target="_blank"
            href="https://www.instagram.com/ozzachranzajka?igsh=dnNiMHBmcnljOGFo"
          >
            <PiInstagramLogo />
          </a>
        </div>
        <div className='contact-section1-button'>
          <a href='https://t.me/+sRoHEVX5Yes1MTY8' target='_blank'><button>Pripojte sa k nám <PiTelegramLogoBold /></button></a>
        </div>
      </div>
    </div>
  );
};

export default Contact;
